import { AuthenticateWithRedirectCallback } from "@clerk/clerk-react"

const SSOCallbacks = () => {
	return <AuthenticateWithRedirectCallback />
}

export default SSOCallbacks
